function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
// Compiler result to JSON file
import { createComponent } from 'js/declViewModelService';
import { registerDynImportEntry } from 'js/moduleLoader';
import AwParseService from 'js/awParseService';
import AwFilterService from 'js/awFilterService';
import { getField } from 'js/utils';
import { Fragment } from 'react';
let filterSer = AwFilterService.instance;
import AwPanel from 'viewmodel/AwPanelViewModel';
import AwFlexRow from 'viewmodel/AwFlexRowViewModel';
import AwSplmTable from 'viewmodel/AwSplmTableViewModel';
import AwImage from 'viewmodel/AwImageViewModel';
import AwLink from 'viewmodel/AwLinkViewModel';

/*
ctx imports
*/

const ctxImportObj = {};

/*
dynamic import
 */
registerDynImportEntry('js/rfqHelper', () => import('js/rfqHelper'));
registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/accEventBus', () => import('js/accEventBus'));
registerDynImportEntry('js/appCtxService', () => import('js/appCtxService'));
;

/*
view model
 */
const declViewModelJson = {
  "schemaVersion": "1.0.0",
  "actions": {
    "performPostCreateRfqBatchAction": {
      "actionType": "batchJob",
      "steps": [{
        "action": "showTable"
      }, {
        "action": "refreshRfqTable"
      }]
    },
    "publishCreateRfqEvent": {
      "actionType": "JSFunction",
      "method": "publishEvent",
      "inputData": {
        "eventName": "create-rfq-event"
      },
      "deps": "js/rfqHelper"
    },
    "getRfqs": {
      "actionType": "JSFunctionAsync",
      "method": "createHttpRequest",
      "inputData": {
        "request": {
          "method": "POST",
          "url": "/acc/orchestrate",
          "withCredentials": true,
          "data": {
            "appBaseUrl": "assets",
            "additionalProperties": {},
            "query": "query getRfqs( $getRfqsInput: ListRfqsInput, $filters: Json) { getRfqs( getRfqsInput: $getRfqsInput, filters: $filters) { items totalCount error}}",
            "variables": {
              "getRfqsInput": {
                "collaborationspaceId": "{{props.collaborationspaceid}}",
                "skip": "{{data.dataProviders.exampleDataProvider.startIndex}}"
              },
              "filters": "{{data.columnProviders.exampleColumnProvider.columnFilters}}"
            }
          }
        },
        "progressIndicatorPrefix": "collab",
        "accSessionId": "{{props.accsessionid}}"
      },
      "dataParsers": [{
        "id": "rfqParser",
        "responseObjs": "data.data.getRfqs.items"
      }],
      "outputData": {
        "filterResults": "data.data.getRfqs.items",
        "totalFound": "data.data.getRfqs.totalCount",
        "error": "data.data.getRfqs.error"
      },
      "actionMessages": {},
      "events": {
        "success": [{
          "condition": "error === null || error === undefined",
          "name": "list-rfqs-as-list.success"
        }, {
          "condition": "error === 'EMPTY_COLLAB_SPACE'",
          "name": "list-rfqs-as-list.error",
          "eventData": {
            "error": "{{i18n.EMPTY_COLLAB_SPACE}}",
            "errorCode": 400
          }
        }, {
          "condition": "error.statusCode === 400 || errorCode === 400",
          "name": "list-rfqs-as-list.error",
          "eventData": {
            "error": "{{error}}",
            "errorCode": 400
          }
        }, {
          "condition": "error.statusCode === 403 || errorCode === 403",
          "name": "list-rfqs-as-list.error",
          "eventData": {
            "error": "{{i18n.FORBIDDEN}}",
            "errorCode": 403
          }
        }, {
          "condition": "error.statusCode === 401 || errorCode === 401 || errorCode === 'INVALID_ACC_SESSION_ID'",
          "name": "list-rfqs-as-list.error",
          "eventData": {
            "error": "{{i18n.UNAUTHORIZED}}",
            "errorCode": 401
          }
        }, {
          "condition": "error.statusCode >= 500 && error.statusCode <= 599",
          "name": "list-rfqs-as-list.error",
          "eventData": {
            "error": "{{i18n.ACC_SERVER_ERROR}}",
            "errorCode": 500
          }
        }],
        "failure": [{
          "name": "list-rfqs-as-list.error",
          "eventData": {
            "error": "{{i18n.ACC_SERVER_ERROR}}",
            "errorCode": 500
          }
        }]
      },
      "deps": "js/accHttpService"
    },
    "deleteRfq": {
      "actionType": "JSFunctionAsync",
      "method": "createHttpRequest",
      "inputData": {
        "request": {
          "method": "POST",
          "url": "/acc/orchestrate",
          "withCredentials": true,
          "data": {
            "appBaseUrl": "assets",
            "additionalProperties": {},
            "query": "mutation deleteRfq( $collaborationspaceId: String, $rfqId: String) { deleteRfq( collaborationspaceId: $collaborationspaceId, rfqId: $rfqId) }",
            "variables": {
              "collaborationspaceId": "{{ctx.rfq.collaborationspaceid || props.collaborationspaceid}}",
              "rfqId": "{{ctx.selectedRfqId}}"
            }
          }
        },
        "progressIndicatorPrefix": "collab",
        "accSessionId": "{{ctx.rfq.accsessionid || props.accsessionid}}"
      },
      "outputData": {
        "response": "data.data.deleteRfq",
        "errorCode": "errorCode"
      },
      "events": {
        "success": [{
          "condition": "response.status === 'Completed' || response.status === 'Executing'",
          "name": "delete-rfq.success",
          "eventData": {
            "response": "{{response}}"
          }
        }, {
          "condition": "response.error === 'EMPTY_COLLAB_SPACE'",
          "name": "delete-rfq.error",
          "eventData": {
            "error": "{{i18n.EMPTY_COLLAB_SPACE}}",
            "errorCode": 400
          }
        }, {
          "condition": "response.error.statusCode === 400 || errorCode === 400",
          "name": "delete-rfq.error",
          "eventData": {
            "error": "{{response.error}}"
          }
        }, {
          "condition": "response.error.statusCode === 403 || errorCode === 403",
          "name": "delete-rfq.error",
          "eventData": {
            "error": "{{i18n.FORBIDDEN}}",
            "errorCode": 403
          }
        }, {
          "condition": "response.error.statusCode === 401 || errorCode === 401 || errorCode === 'INVALID_ACC_SESSION_ID'",
          "name": "delete-rfq.error",
          "eventData": {
            "error": "{{i18n.UNAUTHORIZED}}",
            "errorCode": 401
          }
        }, {
          "condition": "response.error.statusCode >= 500 && response.error.statusCode <= 599",
          "name": "delete-rfq.error",
          "eventData": {
            "error": "{{i18n.ACC_SERVER_ERROR}}",
            "errorCode": 500
          }
        }],
        "failure": [{
          "name": "delete-rfq.error",
          "eventData": {
            "error": "{{i18n.ACC_SERVER_ERROR}}",
            "errorCode": 500
          }
        }]
      },
      "deps": "js/accHttpService"
    },
    "refreshRfqTable": {
      "actionType": "dataProvider",
      "method": "exampleDataProvider"
    },
    "showTable": {
      "actionType": "JSFunction",
      "method": "showHideTable",
      "inputData": {
        "divId": "listRfqTableDiv",
        "totalFound": "1"
      },
      "deps": "js/rfqHelper"
    },
    "showHideTable": {
      "actionType": "JSFunction",
      "method": "showHideTable",
      "inputData": {
        "divId": "listRfqTableDiv",
        "totalFound": "{{data.totalFound}}"
      },
      "deps": "js/rfqHelper"
    },
    "publishToACCEventBus": {
      "actionType": "JSFunction",
      "method": "publish",
      "inputData": {
        "eventId": "{{parameters.eventId}}",
        "eventData": "{{parameters.eventData}}"
      },
      "deps": "js/accEventBus"
    },
    "addSelectedRfqIdToCtx": {
      "actionType": "JSFunction",
      "method": "updateCtx",
      "deps": "js/appCtxService",
      "inputData": {
        "name": "selectedRfqId",
        "value": "{{parameters.eventData}}"
      }
    }
  },
  "props": {
    "accsessionid": {
      "type": "string"
    },
    "collaborationspaceid": {
      "type": "string"
    }
  },
  "data": {
    "image1": {
      "dbValue": "/assets/image/typeProjectRequest48.svg"
    },
    "noRfqLink": {
      "displayName": "{{i18n.createRfq}}",
      "type": "STRING",
      "isRequired": "false"
    },
    "pageSize": 3,
    "rfqsSkip": 0
  },
  "onEvent": [{
    "eventId": "exampleDataProvider.selectionChangeEvent",
    "action": "addSelectedRfqIdToCtx",
    "inputArgs": {
      "eventData": "{{eventData.selectedObjects[0].props.rfqId.dbValue}}"
    }
  }, {
    "eventId": "list-rfqs-as-list.success",
    "action": "showHideTable",
    "cacheEventData": true
  }, {
    "eventId": "create-rfq.success",
    "action": "performPostCreateRfqBatchAction",
    "cacheEventData": true
  }, {
    "eventId": "list-rfqs-as-list.error",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-list-rfqs-as-list.error",
      "eventData": {
        "message": "{{eventData.error}}",
        "statusCode": "{{eventData.errorCode}}"
      }
    }
  }, {
    "eventId": "delete-rfq.error",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-delete-rfq.error",
      "eventData": {
        "message": "{{eventData.error}}",
        "statusCode": "{{eventData.errorCode}}"
      }
    }
  }, {
    "eventId": "delete-rfq.success",
    "action": "getRfqs",
    "cacheEventData": true
  }, {
    "eventId": "delete-rfq.success",
    "action": "refreshRfqTable",
    "cacheEventData": true
  }, {
    "eventId": "delete-rfq.success",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-delete-rfq.success",
      "eventData": "{{eventData.response}}"
    }
  }, {
    "eventId": "deleteRfqEvent",
    "action": "deleteRfq",
    "cacheEventData": true
  }, {
    "eventId": "delete-rfq.success",
    "message": "deleteSuccess"
  }],
  "dataProviders": {
    "exampleDataProvider": {
      "action": "getRfqs",
      "response": "{{data.filterResults}}",
      "totalFound": "{{data.totalFound}}",
      "selectionModelMode": "single",
      "inputData": {
        "selectionModel": "{{subPanelContext.selectionModel}}"
      }
    }
  },
  "columnProviders": {
    "exampleColumnProvider": {
      "frozenColumnIndex": 1,
      "columns": [{
        "name": "icon",
        "displayName": "",
        "maxWidth": 30,
        "minWidth": 30,
        "width": 30,
        "enableColumnMenu": false,
        "pinnedLeft": true,
        "enableSorting": false
      }, {
        "name": "name",
        "displayName": "{{i18n.quoteName}}",
        "maxWidth": 150,
        "width": 150,
        "pinnedLeft": true,
        "isTableCommand": true,
        "enableColumnMenu": true,
        "enableSorting": false,
        "isFilteringEnabled": true
      }, {
        "name": "description",
        "displayName": "{{i18n.description}}",
        "minWidth": 150,
        "width": 150,
        "enableColumnMenu": false,
        "enableSorting": false,
        "isFilteringEnabled": true
      }, {
        "name": "status",
        "displayName": "{{i18n.status}}",
        "maxWidth": 300,
        "minWidth": 80,
        "width": 100,
        "enableColumnMenu": true,
        "enableSorting": false,
        "isFilteringEnabled": true
      }, {
        "name": "dueDate",
        "displayName": "{{i18n.dueDate}}",
        "minWidth": 80,
        "width": 80,
        "enableColumnMenu": true,
        "enableSorting": false,
        "isFilteringEnabled": true
      }, {
        "name": "appliedOn",
        "displayName": "{{i18n.appliedOn}}",
        "minWidth": 100,
        "width": 125,
        "enableColumnMenu": false,
        "enableSorting": false
      }, {
        "name": "appliedBy",
        "displayName": "{{i18n.appliedBy}}",
        "minWidth": 100,
        "width": 125,
        "enableColumnMenu": false,
        "enableSorting": false
      }, {
        "name": "creationDate",
        "displayName": "{{i18n.creationDate}}",
        "minWidth": 150,
        "width": 150,
        "enableColumnMenu": false,
        "enableSorting": false
      }, {
        "name": "rfqId",
        "displayName": "{{i18n.rfqId}}",
        "minWidth": 100,
        "width": 100,
        "enableColumnMenu": true,
        "enableColumnHiding": true,
        "enableSorting": false,
        "isFilteringEnabled": true
      }]
    }
  },
  "grids": {
    "listRfqTable": {
      "dataProvider": "exampleDataProvider",
      "columnProvider": "exampleColumnProvider",
      "addIconColumn": true,
      "gridOptions": {
        "enablePinning": true,
        "isFilteringEnabled": true,
        "enableColumnHiding": true,
        "enableGridMenu": true
      }
    }
  },
  "functions": {
    "filterRows": {
      "functionName": "filterRows",
      "parameters": ["{{data.dataProviders.exampleDataProvider.startIndex}}", "{{data.pageSize}}"]
    }
  },
  "i18n": {
    "quoteName": ["RfqMessages"],
    "dueDate": ["RfqMessages"],
    "appliedBy": ["RfqMessages"],
    "appliedOn": ["RfqMessages"],
    "name": ["RfqMessages"],
    "status": ["RfqMessages"],
    "creationDate": ["RfqMessages"],
    "description": ["RfqMessages"],
    "owner": ["RfqMessages"],
    "emptyRfqs": ["RfqMessages"],
    "createRfq": ["RfqMessages"],
    "ACC_SERVER_ERROR": ["errorMessages"],
    "EMPTY_COLLAB_SPACE": ["errorMessages"],
    "BAD_REQUEST_CREATE_RFQ": ["errorMessages"],
    "FORBIDDEN": ["errorMessages"],
    "UNAUTHORIZED": ["errorMessages"],
    "rfqId": ["RfqMessages"]
  },
  "messages": {
    "deleteSuccess": {
      "messageType": "INFO",
      "messageText": "RFQ got deleted successfully."
    }
  },
  "dataParseDefinitions": {
    "rfqParser": {
      "identifier": "{{response.rfqId}}",
      "typeIconURL": "http://localhost:4012/assets/images/cmdQuoteRequestsList16.svg",
      "type": "RFQ",
      "props": {
        "name": {
          "name": "{{i18n.quoteName}}",
          "displayName": "{{i18n.quoteName}}",
          "value": "{{response.name}}",
          "displayValue": "{{response.name}}",
          "type": "String"
        },
        "status": {
          "name": "{{i18n.status}}",
          "displayName": "{{i18n.status}}",
          "value": "{{response.status.name}}",
          "displayValue": "{{response.status.name}}",
          "type": "String"
        },
        "description": {
          "name": "{{i18n.description}}",
          "displayName": "{{i18n.description}}",
          "value": "{{response.description}}",
          "displayValue": "{{response.description}}",
          "type": "String"
        },
        "dueDate": {
          "name": "{{i18n.dueDate}}",
          "displayName": "{{i18n.dueDate}}",
          "value": "{{response.dueDate}}",
          "displayValue": "{{response.dueDate}}",
          "type": "String"
        },
        "appliedOn": {
          "name": "{{i18n.appliedOn}}",
          "displayName": "{{i18n.appliedOn}}",
          "value": "{{response.status?.appliedOn}}",
          "displayValue": "{{response.status?.appliedOn}}",
          "type": "String"
        },
        "appliedBy": {
          "name": "{{i18n.appliedBy}}",
          "displayName": "{{i18n.appliedBy}}",
          "value": "{{response.status?.appliedBy}}",
          "displayValue": "{{response.status?.appliedBy}}",
          "type": "String"
        },
        "creationDate": {
          "name": "{{i18n.creationDate}}",
          "displayName": "{{i18n.creationDate}}",
          "value": "{{response.creationDate}}",
          "displayValue": "{{response.creationDate}}",
          "type": "String"
        },
        "rfqId": {
          "name": "{{i18n.rfqId}}",
          "displayName": "{{i18n.rfqId}}",
          "value": "{{response.rfqId}}",
          "displayValue": "{{response.rfqId}}",
          "type": "String",
          "enableColumnHiding": true
        }
      }
    }
  },
  "_viewModelId": "ListRfqsAsList",
  "_uniqueViewModelId": "ListRfqsAsList",
  "ctx": {
    "rfq": {
      "type": "object"
    },
    "selectedRfqId": {
      "type": "object"
    }
  }
};

/*
<aw-panel class="aw-layout-full">
    <aw-flex-row height="fill" width="fill" class="afx-content-background">
        <div id="listRfqTableDiv" class="rfqHidden" width="fill">
        <aw-splm-table gridid="listRfqTable"></aw-splm-table>
    </div>
        <br>
        <div id="listRfqTableDiv-empty" class="rfqEmptyPage">
            <br>
            <aw-image source="data.image1.dbValue" class="emptyImage"></aw-image>
            <br>
            <h2>{{i18n.emptyRfqs}}</h2>
            <br>
            <h3><aw-link class="emptyLink" prop="data.noRfqLink" action="publishCreateRfqEvent"></aw-link></h3>
        </div>
    </aw-flex-row>
</aw-panel>


*/
const renderFn = props => {
  let subPanelContext = props.subPanelContext;
  let {
    viewModel: {
      data,
      dataProviders,
      dispatch,
      conditions,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    },
    grids,
    ctx,
    actions,
    fields,
    messages,
    i18n,
    formProp,
    viewPath
  } = props;
  data = {
    ...data,
    dataProviders
  };
  if (subPanelContext && subPanelContext.fields) {
    fields = {
      ...fields,
      ...subPanelContext.fields
    };
  }
  let $index = null;
  return /*#__PURE__*/React.createElement(AwPanel, {
    revealAction: actions.reveal,
    className: "aw-layout-full"
  }, /*#__PURE__*/React.createElement(AwFlexRow, {
    height: "fill",
    width: "fill",
    className: "afx-content-background"
  }, /*#__PURE__*/React.createElement("div", {
    id: "listRfqTableDiv",
    className: "rfqHidden",
    width: "fill"
  }, /*#__PURE__*/React.createElement(AwSplmTable, grids.listRfqTable)), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
    id: "listRfqTableDiv-empty",
    className: "rfqEmptyPage"
  }, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(AwImage, {
    source: AwParseService.instance("data.image1.dbValue")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    className: "emptyImage"
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("h2", null, AwParseService.instance("i18n.emptyRfqs")({
    props,
    data,
    fields,
    dataProviders,
    ctx,
    i18n,
    actions,
    subPanelContext,
    viewPath,
    conditions,
    formProp,
    dispatch,
    selectionModels,
    editHandlers,
    chartProviders,
    ports
  })), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("h3", null, /*#__PURE__*/React.createElement(AwLink, _extends({
    className: "emptyLink"
  }, getField("data.noRfqLink", fields, $index, null, null), {
    action: actions.publishCreateRfqEvent
  }))))));
};

/*
define component
*/
const Component = createComponent(declViewModelJson, renderFn, undefined, ctxImportObj);
export default Component;